import {
  Button,
  DialogActions,
  DialogContent,
  Icons,
  useSwipeableViews,
  Typography,
  Stack,
  tokens,
} from '@cast/design-system';

import { AgentCodeSnippet } from 'components/code';
import { useCredentialsScriptQuery } from 'hooks/queries/cluster';

import { CAN_VIEW_SECURITY } from '../../../../../../constants';
import { AssignCredentialsDialogHeader } from '../../../_components/AssignCredentialsDialogHeader';

type Props = {
  onClose: () => void;
  clusterId: string;
};

export const RunTheScriptSlide = ({ onClose, clusterId }: Props) => {
  const swipeableViewsCtx = useSwipeableViews();
  const { isLoading, script, error, refetch } = useCredentialsScriptQuery({
    id: clusterId,
    installSecurityAgent: CAN_VIEW_SECURITY(),
    installAutoscalerAgent: true,
  });

  return (
    <Stack position="relative">
      <AssignCredentialsDialogHeader dismiss={onClose} />
      <DialogContent sx={{ pb: 0 }}>
        <Stack direction="row" alignItems="center" gap={24} mb={24}>
          <Stack gap={4}>
            <Typography variant="h6">Kubernetes & cloud security</Typography>
            <Typography variant="P12R" color="textSecondary">
              Protect your cluster with real-time threat detection,
              vulnerability scanning, and proactive security measures
            </Typography>
          </Stack>
          <Icons.CastSecurity
            size={36}
            css={{ flexShrink: 0 }}
            variant="preset"
            weight="light"
          />
        </Stack>

        <Typography
          variant="L10M"
          color={tokens.theme.fg.structural.secondary}
          mb={8}
        >
          RUN THE SCRIPT:
        </Typography>
      </DialogContent>
      <DialogContent sx={{ py: 16, backgroundColor: 'grey.100' }}>
        <AgentCodeSnippet
          code={script}
          isLoading={isLoading || !script}
          error={error}
          refetch={refetch}
        />
      </DialogContent>
      <DialogActions sx={{ py: 16 }}>
        <Button
          onClick={() => swipeableViewsCtx?.goToNextSlide()}
          testId="i-ran-script-button"
        >
          I ran the script
        </Button>
      </DialogActions>
    </Stack>
  );
};
